import React from 'react'
import ProgressBar, { ProgressType, ThresholdClasses } from '../../Components/ProgressBar'

export interface ParticipationProgressProps {
	seatsLeft: number
	maximumParticipants: number
}

export function ParticipationProgress(props: ParticipationProgressProps) {

	// Increment bar as participation increases
	const seatProps = {
		progress: props.maximumParticipants - props.seatsLeft, 
		total: props.maximumParticipants, 
	}

	const thresholdClasses: ThresholdClasses = {
		0: 'is-success',
	}

	thresholdClasses[props.maximumParticipants - 5] = 'is-warning'
	thresholdClasses[props.maximumParticipants - 2] = 'is-danger'

	const progressType: ProgressType = 'inc'

	// could switch back to decrementing to match text caption
	/*
	const seatProps = {
		progress: props.seatsLeft, 
		total: props.maximumParticipants
	}

	const thresholdClasses: ThresholdClasses = {
		10: 'is-danger',
		30: 'is-warning',
		100: 'is-success'
	}

	const progressType: ProgressType = 'dec'
	*/

	const progProps = { ...seatProps, ...{ thresholdClasses, progressType } }

	return <ProgressBar {...progProps} thresholdType='value' />
}